import {
    CommentOutlined,
    CustomerServiceOutlined,
    DashboardOutlined,
    HistoryOutlined,
    MessageOutlined,
    ProjectOutlined,
    SettingOutlined,
    TeamOutlined,
} from '@ant-design/icons';
import { MenuProps } from 'antd';

import { AppRoute } from './main.constants';

export type HeaderNavMenuItem = Required<MenuProps>['items'][number];

const statisticsItem: HeaderNavMenuItem = {
    label: 'Статистика',
    key: AppRoute.Statistics,
    icon: <DashboardOutlined />,
};

const projectsItem: HeaderNavMenuItem = {
    label: 'Проекти',
    key: AppRoute.Projects,
    icon: <ProjectOutlined />,
};

const objectionsItem: HeaderNavMenuItem = {
    label: 'Робота з запереченнями',
    key: AppRoute.Objections,
    icon: <MessageOutlined />,
};

const usersItem: HeaderNavMenuItem = {
    label: 'Користувачі',
    key: AppRoute.Users,
    icon: <TeamOutlined />,
};

const historyItem: HeaderNavMenuItem = {
    label: 'Історія дій',
    key: AppRoute.Events,
    icon: <HistoryOutlined />,
};

const supportTicketsItem: HeaderNavMenuItem = {
    label: 'Підтримка',
    key: AppRoute.SupportTickets,
    icon: <CustomerServiceOutlined />,
};

const settingsItem: HeaderNavMenuItem = {
    label: 'Налаштування',
    key: AppRoute.Settings,
    icon: <SettingOutlined />,
};

const commentsItem: HeaderNavMenuItem = {
    label: 'Коментарі',
    key: AppRoute.Comments,
    icon: <CommentOutlined />,
};

export const getHeaderNavItems = (role: string | undefined): HeaderNavMenuItem[] => {
    switch (role) {
        case 'super_admin':
            // supportTicketsItem — розділ прихований
            return [projectsItem, objectionsItem, usersItem, historyItem, statisticsItem, commentsItem, settingsItem];
        case 'admin':
            return [projectsItem, objectionsItem, usersItem, historyItem, statisticsItem, commentsItem, settingsItem];
        case 'script_writer':
            return [projectsItem, objectionsItem, commentsItem, settingsItem];
        case 'manager':
            return [projectsItem, objectionsItem];
        default:
            return [];
    }
};
